module.exports = __webpack_public_path__ + "static/01-06af1d0d1c24291067529619e0266ffb.jpg";